import Components from "./components";
import Pipes from "./pipes";
import Service from "./service";
import Store from "./store";

const ModuleName = "tfApp.news";

const dependencies = [
    Components(ModuleName),
    Pipes(ModuleName),
    Service(ModuleName),
    Store(ModuleName)
];

export default angular.module(ModuleName, dependencies)
                      .name;
